import React, { ReactElement } from 'react';

const SvgContainer = ({ children }: { children: ReactElement | ReactElement[] }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            {children}
        </svg>
    );
};

export default SvgContainer;
